import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import Rating from '@/evaluations/entities/rating'
import Score from '@/evaluations/entities/score'
import CandidateJudge from '@/evaluations/models/candidate-judge'
import JudgeScore from '@/evaluations/models/judge-score'

class RatingService {
  public async findOneAsync(id: string) {
    const res = await axios.get<Rating>(`ratings?id=${id}`)
    return Responses.obj(res)
  }

  public async findForEvaluation(id: string) {
    const res = await axios.get<Rating[]>(
      `ratings/find/forevaluation?evaluationId=${id}`
    )
    return Responses.obj(res)
  }

  public async findForCandidate(evaluationId: string, candidateId: string) {
    const res = await axios.get<Score[]>(
      `ratings/find/forcandidate?evaluationId=${evaluationId}&candidateId=${candidateId}`
    )
    return Responses.obj(res)
  }

  public async findForAssessors(evaluationId: string, candidateId: string) {
    const res = await axios.get<JudgeScore[]>(
      `ratings/find/assessorssummary?evaluationId=${evaluationId}&candidateId=${candidateId}`
    )
    return Responses.list(res)
  }

  public async createAsync(entity: Rating) {
    const res = await axios.post<Rating>(`ratings`, entity)
    return Responses.obj(res)
  }
  public async updateAsync(entity: Rating) {
    const res = await axios.put<Rating>(`ratings`, entity)
    return Responses.obj(res)
  }

  public async saveScoresAsync(entities: Rating[]) {
    const res = await axios.post<Rating[]>(`ratings/savescores`, entities)
    return Responses.obj(res)
  }

  public async deleteAsync(id: string) {
    await axios.post(`ratings/delete?id=${id}`)
  }

  public async candidatesSummary(id: string) {
    const res = await axios.get<Score[]>(
      `ratings/find/candidatessummary?evaluationId=${id}`
    )
    return Responses.list(res)
  }

  public async findForJudge(eId: string, jId: string, cId: string) {
    const res = await axios.get<Rating[]>(
      `ratings/find/forjudge?evaluationId=${eId}&judgeId=${jId}&candidateId=${cId}`
    )
    return Responses.list(res)
  }

  public async candidateJudge(id: string) {
    const res = await axios.get<CandidateJudge[]>(
      `ratings/find/candidatejudge?evaluationId=${id}`
    )
    return Responses.list(res)
  }
}

export default new RatingService()
